import React, { useState } from 'react';
import { Dropdown } from 'antd';
import TemplateQuestionModal from './TemplateQuestionModal';

const AddQuestionDropdown = ({ onAddNewQuestion,formId,questions }) => {
  const [templateModalVisible, setTemplateModalVisible] = useState(false);

  const items = [
    {
      key: 'new',
      label: 'New Question',
      onClick: onAddNewQuestion
    },
    {
      key: 'template',
      label: 'Template Question',
      onClick: () => setTemplateModalVisible(true)
    }
  ];

  return (
    <>
      <Dropdown
        menu={{ items }}
        placement="bottomRight"
        trigger={['click']}
      >
        <button className="btnSecondary border-0 h-9 px-4">
          + Add Question
        </button>
      </Dropdown>

      <TemplateQuestionModal 
  visible={templateModalVisible}
  onClose={() => setTemplateModalVisible(false)}
  formId={formId}
  existingQuestions={questions}
/>
    </>
  );
};

export default AddQuestionDropdown